module.exports = {
   url:process.env.VUE_APP_APIURL
}